import React from 'react';
import { useQuery } from 'react-apollo';
import GET_TASKS_BY_CAMPAIGN from '../../../../GraphQl/Queries/GET_TASKS_BY_CAMPAIGN';
import TaskThreadController from './TaskThreadController';

const TaskThreadLoader = (props) => {
  const { campaignId } = props;

  const { data, loading, error, refetch } = useQuery(GET_TASKS_BY_CAMPAIGN, {
    variables: {
      where: {
        relatedCampaigns_some: {
          id: campaignId,
        },
      },
      orderBy: 'createdAt_DESC',
    },
    fetchPolicy: 'network-only',
  });

  const tasks = data?.tasksConnection?.edges?.map(edge => edge.node) || [];
  const taskCount = data?.tasksConnection?.aggregate?.count || 0;

  return (
    <TaskThreadController
      {...props}
      tasks={tasks}
      taskCount={taskCount}
      tasksLoading={loading}
      tasksError={error}
      refetchTasks={refetch}
    />
  );
};

export default TaskThreadLoader;
